module.exports = __webpack_public_path__ + "img/keylogger.57e307fe.png";